export default class LogicError extends Error {
  static create(status, code, message, data) {
    return new LogicError({
      status,
      code,
      message,
      data
    });
  }

  constructor({
    status = 200,
    code = 400,
    message = 'Unknown portal error',
    comment,
    data = null
  } = {}) {
    super(message);
    this.status = status;
    this.code = code;
    this.data = data;
    this.msg = message;
    this.comment = comment || message;
  }

  toString() {
    return JSON.stringify(this);
  }
}